export default {
    // Backend: set VUE_APP_F2_BASE_URL in .env.development.local (gitignored) to point `serve` at
    // another backend, e.g. http://localhost:3000. Builds without it use production.
    f2BaseURL: process.env.VUE_APP_F2_BASE_URL || 'https://fedrogustoautentico.framework2.dev',
    filesApi: '/app-key/fedro/api/files/',
    graphqlURL: '/api/graphql',
    // adminurl: '/api/testschema',
    applicationKey: 'fedro',
    adminRoleUid: '0001692699765222-iNWd6CsyZb',
    contentManagerRoleUid: '0001692699791234-bHSuA1TlDo',
};
